<template>
  <div class="" :class="[$route.meta.fullscreen || runningElectron ? '' : 'application application-in-browser']">

    <div v-if="$route.meta.fullscreen || runningElectron" class="h-screen flex flex-col min-h-[700px] "
         :class="{'p-6' : $route.meta.screenPadding && !runningElectron}">

      <div v-if="showCustomTitlebar" class="electron:bg-electron-title-bar">
        <main-menu v-if="!$route.meta?.hideNavbar" :toggle-dark-mode="toggleDarkMode"
                   :in-electron="runningElectron"></main-menu>
      </div>
      <div v-else-if="!runningElectron">
        <main-menu v-if="!$route.meta?.hideNavbar" :toggle-dark-mode="toggleDarkMode"
                   :in-electron="runningElectron"></main-menu>
      </div>

      <div v-if="runningElectron" class="flex-grow flex flex-col overflow-hidden bg-electron-title-bar ">

        <div v-if="showCustomTitlebar"  class="border-[#ffffff30] border-b flex">
          <div class="flex-grow  justify-center flex items-center flex-shrink-0  p-2 gap-2">
            <i class="fa-solid fa-rotate-right p-2 round hover:bg-trader-dark-gray cursor-pointer text-white" @click="reloadPage"></i>
            <i class="fa-regular fa-clipboard p-2 round hover:bg-trader-dark-gray cursor-pointer text-white" @click="copyToClipboard(currentUrl)"></i>
            <input class="flex-grow p-1 rounded bg-transparent text-white" v-model="currentUrl" @click="$event.target.select()" @keyup.enter="openUrl">
          </div>
        </div>

        <div class="flex-grow flex flex-col overflow-auto electron:bg-electron-background">
          <router-view/>
        </div>

      </div>
      <router-view v-else/>
      <Modal/>
    </div>

    <div v-else class="">
      <main-menu :toggle-dark-mode="toggleDarkMode"></main-menu>
      <router-view/>
      <Modal/>
    </div>

  </div>
</template>

<script>
//import axios from 'axios';
import {computed, inject, onMounted, ref, watch} from 'vue';
import Modal from './components/Dialogs/Modal.vue';
import MainMenu from "./components/MainMenu/MainMenu";
import {useRoute} from "vue-router";
import {electron} from "@/electron";


export default {
  name: "App",
  components: {
    MainMenu,
    Modal
  },

  setup() {

    const store = inject('store');

    // Store the route object
    const route = useRoute();

    const isDarkMode = computed(() => {
      return store?.state?.settings?.theme === 'dark';
    });

    const selectLanguage = (lang) => {
      window.i18n.global.locale = lang;
    }

    const runningElectron = ref(window.runningElectron);

    const currentUrl = ref('');

    const showCustomTitlebar = electron.getWindowCustomData("showCustomTitlebar")


    const applicationWidth = ref(null);
    if (typeof window.maxApplicationWidth !== "undefined") {
      applicationWidth.value = window.maxApplicationWidth;
    }

    // Funktion zum Aktualisieren des Dark Mode Status
    const updateDarkMode = () => {

      //check if url starts with /login then use light theme
      if (route.meta?.theme === "light") {
        document.documentElement.classList.remove('dark');
        document.body.classList.remove('dark-trader-background'); // Hintergrundfarbe im Light Mode zurücksetzen
        return;
      }

      if (isDarkMode.value) {
        document.documentElement.classList.add('dark');
        document.body.classList.add('dark-trader-background'); // Hier die Hintergrundfarbe im Dark Mode setzen
      } else {
        document.documentElement.classList.remove('dark');
        document.body.classList.remove('dark-trader-background'); // Hintergrundfarbe im Light Mode zurücksetzen
      }
    };

    const toggleDarkMode = () => {
      let isDark = store?.state?.settings?.theme === 'dark'
      isDark = !isDark;
      store?.commit('settings/setTheme', isDark ? 'dark' : 'light');
      store.dispatch('settings/setTheme', isDark ? 'dark' : 'light');
      updateDarkMode();
    }

    const copyToClipboard = (text) => {
      navigator.clipboard.writeText(text).then(() => {
        
      }, (err) => {
        console.error('Error copying text to clipboard', err);
      });
    }

    const reloadPage = () => {
      window.location.reload();
    }

    onMounted(() => {
      updateDarkMode();
      currentUrl.value = window?.location?.href;

      if (runningElectron.value) {
        document.body.classList.add('electron');
        document.documentElement.classList.add('electron');
      }
    });

    const openUrl = () => {
      
      //switch to the new url
      window.location.href = currentUrl.value;
    }



    watch(
        () => route.path, // Use the stored route object
        () => {
          
          currentUrl.value = window?.location?.href;
          updateDarkMode();
        }
    );

    return {
      selectLanguage,
      applicationWidth,
      isDarkMode,
      toggleDarkMode,
      runningElectron,
      currentUrl,
      copyToClipboard,
      reloadPage,
      openUrl,
      showCustomTitlebar
    };
  },
  created() {
  }
}

</script>

<style lang="less">


.application {
  &.application-in-electron {
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    margin: 0px !important;
    padding: 0px !important;
  }

  &.application-in-browser {
    margin: 0 auto;
    width: 100%;
    max-width: 996px;
    margin-bottom: 20px !important;
    margin-top: 20px !important;
  }

  &.application-administration {
    max-width: none !important;
    padding: 20px;
    margin-top: 0 !important;

    /*
    position: absolute;
    overflow: hidden;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    */

  }
}

.application-container {
  &.application-in-electron {
    position: absolute;
    top: 40px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    margin: 0px !important;
    padding: 0px !important;
  }
}

.app-container {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: stretch;
  align-items: flex-start;
  position: absolute;
  top: 0px;
  bottom: 0px;

  &.application-in-browser {
    width: 100%;
    max-width: 996px !important;
    min-width: 996px !important;
    margin: 20px 0px;
  }

  &.application-in-electron {
    left: 0;
    right: 0;
  }

  .app-container-header {
    order: 0;
    flex: 0 0 auto;
    align-self: stretch;
  }

  .app-container-content {
    order: 0;
    flex: 1 1 auto;
    align-self: stretch;
  }
}

*.unselectable {
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;

  /*
    Introduced in Internet Explorer 10.
    See http://ie.microsoft.com/testdrive/HTML5/msUserSelect/
  */
  -ms-user-select: none;
  user-select: none;
}

.language-button {
  cursor: pointer;
  margin: 5px;
  padding: 5px;
  background: #efefef;
}

body {
  margin: 0px;
  padding: 0px;
  font-family: Arial, sans-serif;
  font-size: 11px;
  overscroll-behavior-y: none;
  overscroll-behavior-x: none;
}

#app {
  //font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

}

#nav {
  background: rgb(100, 100, 100);
  color: white !important;
  height: 25px;
  line-height: 25px;

  padding: 0px;
}

#nav a {
  color: white;
  padding: 0px 15px;
  height: 25px;
  text-decoration: none;
  display: inline-block;
}

#nav a.router-link-exact-active {
  background: #576b80;
  cursor: pointer;
}

.tabs ul li {
  padding-left: 5px !important;
  padding-right: 5px !important;
}

.app-version {
  position: fixed;
  bottom: 10px;
  right: 10px;
  text-shadow: 0px 0px 10px #FFFFFF;
  color: #222;
}

.changed {
  background: #e7b7c1 !important;
}
</style>